module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "structure-next",
    attrs: {
      "id": "calibre_pb_2"
    }
  }, [_c('span', {
    staticClass: "bold1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "free-form1"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Live with Intention")])]), _vm._v(" "), _c('p', {
    staticClass: "free-form2"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("Remember "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("and Do What Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Mary Anne Radmacher")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/ConariPress(logo)BW-01.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("Mango Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1",
    attrs: {
      "id": "calibre_pb_3"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a141c00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/LiveWithIntention_split_001.vue
// module id = 63
// module chunks = 0